import GetIconByName from '@bimser/icons/lib/getIcon16ByName';
import BCButton from '../../../BCButton';
import { IPropertyComponentProps } from '../../entities';

export default function ButtonProperty(props: IPropertyComponentProps) {
	const getIcon = () => {
		const Icon = GetIconByName(props.item.options?.icon);
		return <Icon />;
	};

	return (
		<BCButton
			onClick={props.item.options?.onClick}
			text={props.item.options?.text}
			icon={getIcon()}
			size="small"
			disabled={props.readonly}
		>
			{props.item.label}
		</BCButton>
	);
}
